import { useEffect, useState } from "react";
import style from "../css/DispenseCode.module.css";
import NavBar from "../../../commonComponent/Drawer/NavBar";
import Header from "../component/Header";
import { ChevronRight } from "lucide-react";
import { contactUsUTR, offerEvent } from "../../../utils/api";
import { useNavigate } from "react-router-dom";
import badge from "../../../icons/utrIcons/Vector.svg";

import UAParser from "ua-parser-js";
import { ErrorHandling } from "../../../State";
import icon1 from "../../../icons/utrIcons/Group 1000004707.svg";
import icon2 from "../../../icons/utrIcons/Group 1000004708.svg";
import icon3 from "../../../icons/utrIcons/Group 1000004710.svg";
import iconUTR from "../../../icons/utrIcons/Group 1000004711.svg";
import banner from "../../../icons/utrIcons/utrBanner.webp";

function UTRDispenseCode() {
  const navigate = useNavigate();

  const [utrNumber, setUtrNumber] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [dispenseCode, setDispenseCode] = useState("");

  const UTR_REGEX = /^[A-Za-z0-9@._-]+$/;

  let uuid = localStorage.getItem("uuid");
  let mId = localStorage.getItem("mId") || "2026";
  let session_id = localStorage.getItem("session_id");

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();
      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        user_id: localStorage.getItem("userId") || "",
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");
      return null;
    }
  };

  const avail = async (eventScreen, eventSubName, eventType, eventSubType) => {
    try {
      const eventMetaData = {
        Event_Name: eventScreen,
        Event_Sub_Name: eventSubName,
        Event_Type: eventType,
        Event_Sub_Type: eventSubType,
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) {
        return;
      }

      await offerEvent(requestData);
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to process your request right now",
      );
    }
  };

  const handleUTRChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setUtrNumber("");
      setError("");
      return;
    }

    if (!UTR_REGEX.test(value)) {
      setError("UTR Number can contain only letters and numbers.");
      return;
    }

    setUtrNumber(value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!utrNumber.trim()) {
      setError("Please enter your UTR Number.");
      return;
    }

    if (!UTR_REGEX.test(utrNumber)) {
      setError("UTR Number can contain only letters and numbers.");
      return;
    }

    try {
      setIsSubmitting(true);
      setError("");

      const response = await contactUsUTR(utrNumber);

      if (response.success) {
        const code = response?.message.dispense_pin;

        if (code) {
          setDispenseCode(code);
          avail("Dispense_Code_Open", "UTR_Page", "Open", "utr_submit");
        } else {
          setError(response.message);
        }
      } else {
        setError(response.message);
      }
      avail("UTR_Submit_Click", "UTR_Page", "Click", "utr_submit");
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    avail("UTR_Page", "Product_Page", "Page_Open", "get_help");
  }, []);

  return (
    <div className={style.homeContainer}>
      <Header navText="PunnyaDhara" />

      <div className={style.navBarAlign}>
        <NavBar />
      </div>

      {/* Heading */}
      <p
        className={style.headingText}
        style={{
          marginTop: "18px",
          marginBottom: "0",
        }}
      >
        Didn't get your
      </p>

      <p
        className={style.headingText}
        style={{
          color: "#ED1967",
          marginLeft: "4px",
          fontWeight: "600",
          marginBottom: "20px",
        }}
      >
        Dispense Code?
      </p>

      <div className={style.stepsContainer}>
        <div className={style.stepsCard}>
          <img src={icon1} alt="Enter UTR" />
          <p>Enter your UTR / UPI ID</p>
        </div>

        <div className={style.stepLine} />

        <div className={style.stepsCard}>
          <img src={icon2} alt="Submit" />
          <p>Submit</p>
        </div>

        <div className={style.stepLine} />

        <div className={style.stepsCard}>
          <img src={icon3} alt="Get dispense code" />
          <p>Get your Dispense Code</p>
        </div>
      </div>

      {!dispenseCode ? (
        <>
          {/* Where to find UTR */}
          <div
            className={style.utrDetailBox}
            onClick={() => {
              navigate("/utr-info");
              avail("UTR_Info_Click", "UTR_Page", "Click", "utr_info");
            }}
          >
            <img src={badge} style={{ color: "#ED1967" }} />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "8px",
                flex: 1,
              }}
            >
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#ED1967",
                }}
              >
                Where to find UTR Number?
              </span>

              <span
                style={{
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "#000000",
                }}
              >
                You can find it in your bank / app payment history.
              </span>
            </div>

            <ChevronRight
              style={{
                color: "#D91A5E",
                marginRight: "10px",
              }}
              size={28}
            />
          </div>
          {/* Description */}
          <p
            style={{
              color: "#000000",
              fontSize: "13px",
              fontWeight: "400",
              margin: "25px 42px",
              textAlign: "center",
            }}
          >
            Enter the <span style={{ fontWeight: "600" }}>UTR Number</span> used
            for your payment to receive your dispense code.
          </p>
          <form onSubmit={handleSubmit} className={style.utrForm}>
            <label htmlFor="utrNumber" className={style.utrLabel}>
              UTR Number
            </label>

            <div
              className={`${style.utrInputWrapper} ${
                error ? style.utrInputError : ""
              }`}
            >
              <img
                className={style.utrInputIcon}
                src={iconUTR}
                alt="UTR Icon"
              />

              <input
                id="utrNumber"
                type="text"
                value={utrNumber}
                onChange={handleUTRChange}
                placeholder="Enter the UTR Number"
                autoComplete="off"
                maxLength={50}
              />
            </div>

            {/* Error */}
            {error && <p className={style.errorText}>{error}</p>}

            {/* Example */}
            {!error && (
              <p className={style.exampleText}>
                Example: 123412431980/yourname@upi
              </p>
            )}

            <button
              type="submit"
              className={style.submitButton}
              disabled={!utrNumber || !!error || isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>

          {/* Refund Guarantee */}
          <div className={style.utrDetailBox}>
            <img src={badge} style={{ color: "#ED1967" }} />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "8px",
                flex: 1,
              }}
            >
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#ED1967",
                }}
              >
                Refund Guarantee
              </span>

              <span
                style={{
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "#000000",
                }}
              >
                Refund is automatically processed within 2-3 business days.
              </span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={style.innerPinContainer}>
            <p className={style.pinText}>
              Your <b>DISPENSE CODE</b> is
            </p>

            <div className={style.pinContainer2}>
              {dispenseCode.split("").map((digit, index) => (
                <div key={index} className={style.pinDigit2}>
                  <span className={style.pinBlur2}>{digit}</span>
                </div>
              ))}
            </div>

            <p className={style.pinText}>
              Enter Code in Vending Machine Display
            </p>
          </div>
          <img
            src={banner}
            alt="UTR Icon"
            className={style.bannerImg3}
            onClick={() => {
              navigate("/questions");
              avail("Quiz_Questions", "UTR_Page", "Click", "banner");
            }}
          />
          <div className={style.exploreButtons}>
            <div
              onClick={() => {
                navigate("/hot-deals");
                avail(
                  "Hot_Deals_UTR_Screen",
                  "Hot_Deals_Page",
                  "click",
                  "Screen_Impressions",
                );
              }}
              style={{
                background:
                  "linear-gradient(to bottom, #ED1967 0%, #C10047 100%)",
              }}
              className={style.ctaButtons}
            >
              Hot Deals
            </div>
            <div
              onClick={() => {
                navigate("/questions");
                avail(
                  "Questions_Quiz_UTR_Screen",
                  "Questions_Quiz_Page",
                  "click",
                  "Screen_Impressions",
                );
              }}
              style={{
                background:
                  "linear-gradient(to bottom, #1143B8 0%, #071E52 100%)",
              }}
              className={style.ctaButtons}
            >
              Play Quiz
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UTRDispenseCode;
